module.exports = __webpack_public_path__ + "img/bohai.a27ba194.png";